import { Button, Text } from '@factorialco/deprecated-design-system'
import { RateConfigurationsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  ArchiveRateConfigurationDocument,
  RateConfigurationFormFragment,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  rateConfiguration: RateConfigurationFormFragment
  onClose: () => void
}

const ArchiveRateModal = ({ rateConfiguration, onClose }: Props) => {
  const [archiveRateConfiguration] = useMutation(ArchiveRateConfigurationDocument, {
    extractorFn: (data) => data.expensesMutations.archiveExpensesRateConfiguration,
    refetchQueries: [RateConfigurationsDatatableDocument],
  })

  const handleSubmit = async () => {
    const result = await archiveRateConfiguration({
      variables: { id: rateConfiguration.id },
    })
    const handled = handleResult(result, () => {})

    if (handled.success) {
      app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully') })
      onClose()
    } else {
      app.setFlash({ type: 'wrong', message: i18n.t('errors.generic_saving') })
    }
  }

  return (
    <Modal
      illustration="archive"
      title={i18n.t('expenses_v2.settings.rate_configurations.archive_modal.title')}
      description={i18n.t('expenses_v2.settings.rate_configurations.archive_modal.description')}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.close')}
          </Button>
          <Button onClick={() => handleSubmit()}>{i18n.t('common.archive')}</Button>
        </>
      }
    >
      <Text.Normal>
        {i18n.tView('expenses_v2.settings.rate_configurations.archive_modal.confirm', {
          rate_name: <span className="font-semibold">{rateConfiguration?.name}</span>,
        })}
      </Text.Normal>
    </Modal>
  )
}

export default ArchiveRateModal
